<a class="ds-menu-item" role="menuitem"
   routerLinkActive="active"
   [ngClass]="{'disabled': !hasLink }"
   [attr.aria-disabled]="!hasLink"
   [href]="href"
   target="_blank"
   rel="noopener noreferrer"
   [title]="item.text | translate"
   (click)="$event.stopPropagation()"
>{{item.text | translate}}</a>
